import { render, staticRenderFns } from "./createProfile.vue?vue&type=template&id=067d6b6f"
import script from "./createProfile.vue?vue&type=script&lang=js"
export * from "./createProfile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports